import { createFileRoute } from "@tanstack/react-router";
import { PartnerShell } from "../../../features/partner/components/partner-shell";
import { PartnerMoneyPage } from "../../../features/partner/pages/partner-money-page";

/** `/{lang}/partner/money`: one month's guests and commission (`?month=`). */
export const Route = createFileRoute("/$lang/_partner/partner/money")({
  component: PartnerMoneyRoute,
});

function PartnerMoneyRoute() {
  const { lang } = Route.useParams();
  const search = Route.useSearch();
  return (
    <PartnerShell lang={lang} search={search} tab="money">
      <PartnerMoneyPage search={search} />
    </PartnerShell>
  );
}
